import React, { useEffect, useState } from "react"
import classNames from "classnames"
import { noop } from "lodash-es"
import { create } from "zustand"

import CopperModal from "@/topic/rogue_5/components/CopperModal"
import { SFX } from "@/topic/rogue_5/utils/sfx"
import EffectModal from "./EffectModal"
import LotteryModal from "./LotteryModal"
import RecordModalWrapper from "./RecordModal"
import ResultModal from "./ResultModal"
import ShareModal from "./ShareModal"

import styles from "./index.module.less"
const useCopperModalStore = create<{
    activate: () => void
}>(() => ({
    activate: noop,
}))

export const useCopperModal = () =>
    useCopperModalStore((state) => state.activate)

const GameModalLayer: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const [activeCopperModal, setActiveCopperModal] = useState(false)
    useEffect(() => {
        useCopperModalStore.setState({
            activate: () => {
                SFX.play("copperModal")
                setActiveCopperModal(true)
            },
        })
    }, [])
    return (
        <div
            className={classNames(styles.gameModalLayer, className)}
            style={style}
        >
            <EffectModal />
            <ResultModal />
            <CopperModal
                active={activeCopperModal}
                onClose={() => {
                    setActiveCopperModal(false)
                }}
            />
            <RecordModalWrapper />
            <ShareModal />
            <LotteryModal />
        </div>
    )
}

export default GameModalLayer
